import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as NumPadIcon } from '../../../../../../resource/NumPadIcon.svg';
import RoundIconBackground from '../../../RoundIconBackground/RoundIconBackground';
import { roundIconBgTypes } from '../../../../constants/common';
import { mainContainerId } from '../../../../constants/common';
import { numPadVisibleSelector } from '../../../../store/selectors';
import { setNumPadVisible } from '../../../../store/actions';

const NumPadBtn = () => {
  const dispatch = useDispatch();
  const numPadVisible = useSelector(numPadVisibleSelector);

  const handleClick = () => {
    dispatch(setNumPadVisible(!numPadVisible));
  };

  return (
    <RoundIconBackground
      tooltipTitle="Тональный набор"
      getTooltipContainer={() => document.getElementById(mainContainerId)}
      onClick={handleClick}
      containerType={roundIconBgTypes.transparent}
      renderIcon={({ className }) => <NumPadIcon className={className} />}
    />
  );
};

export default NumPadBtn;
